import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SnowboardingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"snowboarding"}/>
}
